// extracted by mini-css-extract-plugin
export default {"header":"header_header__Pu9J0","main-image":"header_main-image__rx72X"};